export default __webpack_public_path__ + "static/Plots0001-b8aae8ec869dca365dd8c5b586fd9465.jpg";